import {CountryInterface} from "../interfaces";

export const Countries: Array<CountryInterface> = [
  {
    shortCode: "cz",
    name: "Tschechien"
  },
  {
    shortCode: "de",
    name: "Deutschland"
  },
  {
    shortCode: "gb",
    name: "Großbritannien"
  },
  {
    shortCode: "es",
    name: "Spanien"
  },
  {
    shortCode: "fr",
    name: "Frankreich"
  },
  {
    shortCode: "hu",
    name: "Ungarn"
  },
  {
    shortCode: "it",
    name: "Italien"
  },
  {
    shortCode: "kr",
    name: "Südkorea"
  },
  {
    shortCode: "nl",
    name: "Niederlande"
  },
  {
    shortCode: "pl",
    name: "Polen"
  },
  {
    shortCode: "cn",
    name: "Volksrepublik China"
  }
];
